import LegalLayout from './components/LegalLayout';

function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" effectiveDate="July 19, 2026">
      <p>
        MintHub ("MintHub", "we", "us", or "our") respects your privacy. This Privacy
        Policy explains what information we collect through this website (the "Site"),
        how we use it, and the choices you have. By using the Site, you agree to the
        practices described below.
      </p>

      <h2 className="legal-heading">1. Information We Collect</h2>
      <p><strong>Information you provide to us.</strong> When you submit our contact form, we collect:</p>
      <ul>
        <li>Your name</li>
        <li>Your email address</li>
        <li>The message/content you choose to share with us</li>
      </ul>
      <p>
        <strong>Automatically collected information.</strong> Like most websites, our
        hosting provider may automatically log standard technical information such as
        IP address, browser type, device type, and pages visited, for security and
        operational purposes.
      </p>
      <p>
        We do not currently use analytics or advertising cookies. If that changes, we
        will update this Policy and, where required, request your consent before any
        such tracking begins.
      </p>

      <h2 className="legal-heading">2. How We Use Your Information</h2>
      <p>We use the information collected through the contact form to:</p>
      <ul>
        <li>Respond to your inquiry and communicate with you about our services</li>
        <li>Provide you with a quote or proposal, if requested</li>
        <li>Improve and maintain the Site</li>
        <li>Detect and prevent spam or abuse of our contact form</li>
      </ul>
      <p>We do not sell your personal information.</p>

      <h2 className="legal-heading">3. Third-Party Service Providers</h2>
      <p>
        We use <strong>FormSubmit.co</strong> to process and deliver contact form
        submissions to our inbox. When you submit the form, your name, email address,
        and message are transmitted to and processed by FormSubmit.co on our behalf.
        We encourage you to review{' '}
        <a href="https://formsubmit.co/privacy-policy" target="_blank" rel="noopener noreferrer">
          FormSubmit.co's own privacy policy
        </a>{' '}
        for details on how they handle data.
      </p>
      <p>
        Our Site may also link out to our Facebook page. Facebook's collection and use
        of your information is governed by Facebook's own privacy policy, not this one.
      </p>

      <h2 className="legal-heading">4. Data Retention</h2>
      <p>
        We retain contact form submissions for as long as reasonably necessary to
        respond to your inquiry, maintain business records, and comply with legal
        obligations, after which they are deleted or anonymized.
      </p>

      <h2 className="legal-heading">5. Your Rights</h2>
      <p>
        Under Canadian privacy law (including PIPEDA), you have the right to:
      </p>
      <ul>
        <li>Ask what personal information we hold about you</li>
        <li>Request that we correct inaccurate information</li>
        <li>Request that we delete your personal information, subject to legal or legitimate business requirements</li>
        <li>Withdraw consent to our use of your information at any time</li>
      </ul>
      <p>
        To exercise any of these rights, contact us using the details below.
      </p>

      <h2 className="legal-heading">6. Data Security</h2>
      <p>
        We take reasonable technical and organizational measures to protect the
        personal information we handle. However, no method of transmission over the
        internet is completely secure, and we cannot guarantee absolute security.
      </p>

      <h2 className="legal-heading">7. Children's Privacy</h2>
      <p>
        The Site is intended for business audiences and is not directed at children
        under 13. We do not knowingly collect personal information from children.
      </p>

      <h2 className="legal-heading">8. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Changes will be posted on
        this page with an updated effective date. Continued use of the Site after
        changes are posted constitutes acceptance of the updated Policy.
      </p>

      <h2 className="legal-heading">9. Contact Us</h2>
      <p>
        If you have questions about this Privacy Policy or how we handle your
        information, contact us at{' '}
        <a href="mailto:minthub.business@protonmail.com">minthub.business@protonmail.com</a>.
      </p>

      <p className="legal-jurisdiction-note">
        This Policy is governed by the laws of the Province of Ontario, Canada.
      </p>
    </LegalLayout>
  );
}

export default Privacy;
